import React from 'react';
import {
  Container,
  CountDown,
  MatchStartTime,
  Score,
  ScoreWrapper,
  StateWrapper,
  Status,
  TeamLogo,
  TeamNameWrapper,
  TeamWrapper,
  TitleWrapper,
  Button,
  ButtonWrapper,
} from './styled';
import SportsTeamLogo from '../../../teamLogo';
import { observer } from 'mobx-react';
import moment from 'moment';
import 'moment/locale/ko';
import BoxScore from './BoxScore';
import { getStreamBrowser } from '../../../../routes/score/liveStream/util';

const LolMatch = observer(({ gameData }) => {
  const { detail } = gameData;
  const { home, away, gameStatus, startDatetime, leagueName, mediaName } = detail;

  const formattedDateTime = moment(startDatetime).locale('ko').format('MM.DD (ddd) HH:mm');
  const onClickVideo = () => {
    getStreamBrowser(mediaName);
  };

  return (
    <Container>
      <TitleWrapper>
        <TeamWrapper>
          <TeamLogo>
            <SportsTeamLogo imgSize={'70'} imgUrl={home.img_path} isLazy={true} />
          </TeamLogo>
          <TeamNameWrapper>
            <p>{home.name_en}</p>
            <span>{home.rank && `${leagueName} ${home.rank}위`}</span>
          </TeamNameWrapper>
        </TeamWrapper>
        <Status>
          {gameStatus === 'READY' && <CountDownComp detail={detail} />}
          {gameStatus !== 'READY' && <ScoreComp detail={detail} />}

          <MatchStartTime>{formattedDateTime}</MatchStartTime>
          <ButtonWrapper>
            {mediaName && (gameStatus === 'IN_PROGRESS' || gameStatus === 'BREAK_TIME' || gameStatus === 'PAUSE') && (
              <Button onClick={onClickVideo} target={'_blank'} onAir>
                생중계
              </Button>
            )}
          </ButtonWrapper>
        </Status>
        <TeamWrapper>
          <TeamLogo>
            <SportsTeamLogo imgSize={'70'} imgUrl={away.img_path} isLazy={true} />
          </TeamLogo>
          <TeamNameWrapper>
            <p>{away.name_en}</p>
            <span>{away.rank && `${leagueName} ${away.rank}위`}</span>
          </TeamNameWrapper>
        </TeamWrapper>
      </TitleWrapper>

      <BoxScore detail={detail} />
    </Container>
  );
});

const CountDownComp = observer(({ detail }) => {
  return <CountDown>{detail.getCountDownTime}</CountDown>;
});

const ScoreComp = observer(({ detail }) => {
  const { homeScore, awayScore, gameStatus, home, away } = detail;

  return (
    <ScoreWrapper>
      <Score winPosition={homeScore > awayScore}>{homeScore}</Score>
      <StateWrapper>
        <span>{detail.statusText}</span>
        {gameStatus === 'IN_PROGRESS' && <span>{detail.displayTime}</span>}
      </StateWrapper>
      <Score winPosition={awayScore > homeScore}>{awayScore}</Score>
    </ScoreWrapper>
  );
});

export default LolMatch;
